/* ROTAS69: отложенная загрузка картинок ниже фолда по IntersectionObserver вместо нативного
   loading="lazy". Нативный lazy на медленной сети (Slow 4G, effectiveType 3g) стартует всё в
   2500 px от экрана сразу: на мобильной главной до LCP-постера героя успевали скачаться 800–913 КБ
   картинок (32–35 файлов), и постер в 45 КБ ждал 7–8 с (замер 05–06.09.2026, Pixel-класс,
   CPU ×4). Здесь картинка не имеет src, пока не подойдёт на 200 px к экрану.

   Разметка: <img class="r69-lz" data-src="…" data-srcset="…" sizes="…"> — sizes/width/height
   остаются обычными, чтобы место резервировалось сразу. Скрипт подключён в <head> как async:
   пока он не пришёл, картинки без src не грузятся вовсе — постер идёт первым; когда пришёл,
   ближние к экрану получают src в тот же кадр.

   Как находятся новые картинки. Пока документ разбирается, парсер дописывает узлы в конец, и
   раз в кадр TreeWalker идёт от последнего виденного элемента вперёд по новому хвосту: каждый
   элемент страницы посещается один раз за весь разбор, без селекторов и без наблюдателя.
   После DOMContentLoaded узлы вставляют уже скрипты (морф поиска, section rendering, quick-add)
   целыми поддеревьями — с этого момента работает MutationObserver: картинка из записи берётся
   по тегу, поддерево обходится querySelectorAll внутри себя; плюс один полный проход по
   document.images на DOMContentLoaded.
   Первая версия делала querySelectorAll на КАЖДЫЙ добавленный узел прямо в колбэке — во время
   потокового разбора коллекции (10 800 тегов) это были сотни вызовов и ~120 мс главного потока
   при CPU ×4 (профиль загрузки 06.09.2026, Pixel-класс). Вторая обходила document.images раз в
   кадр — живая коллекция после каждой мутации перестраивается заново, 86 мс на том же профиле.
   Третья разбирала записи наблюдателя во время разбора — 51 мс: запись на каждый из 10 000
   узлов создаётся и доставляется независимо от того, насколько дёшев колбэк. */
(function () {
  if (window.r69Lazy) return;
  var SEL = 'img[data-src], img[data-srcset]';
  var seen = typeof WeakSet === 'function' ? new WeakSet() : null;
  // Images that intersected the viewport while hidden by `visibility: hidden` (the closed search
  // panel is laid out under the header with visibility hidden, not display none — its ten category
  // tiles, ~32 KB each, were fetched on EVERY page before the hero: on the article/blog pages a tile
  // came back 40 ms ahead of the hero image, Slow 4G, 07.09.2026). IntersectionObserver only knows
  // boxes, so such images are parked here instead of loaded; watch(root) from the code that reveals
  // the container (r69-search-panel.js open()) — or a `visibility` transition starting on any
  // element — re-arms them, and the observer then fires again with the container visible.
  var deferred = typeof WeakSet === 'function' ? new WeakSet() : null;

  function load(img) {
    var srcset = img.getAttribute('data-srcset');
    var src = img.getAttribute('data-src');
    if (srcset) { img.setAttribute('srcset', srcset); img.removeAttribute('data-srcset'); }
    if (src) { img.setAttribute('src', src); img.removeAttribute('data-src'); }
    img.classList.remove('r69-lz');
    // Морф (поиск, section rendering) может снова поставить data-src на этот же узел —
    // тогда он должен считаться новым и попасть под наблюдение ещё раз.
    if (seen) seen.delete(img);
  }

  var io = 'IntersectionObserver' in window
    ? new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (!entries[i].isIntersecting) continue;
          io.unobserve(entries[i].target);
          if (deferred && getComputedStyle(entries[i].target).visibility === 'hidden') { deferred.add(entries[i].target); continue; }
          load(entries[i].target);
        }
      }, { rootMargin: '200px 0px' })
    : null;

  function observe(img) {
    if (seen) {
      if (seen.has(img) && !(deferred && deferred.has(img))) return;
      seen.add(img);
      if (deferred) deferred.delete(img);
    }
    if (io) io.observe(img); else load(img);
  }

  // Полный проход по document.images: дёшево (живая коллекция без селекторов), поэтому его можно
  // звать хоть каждый кадр во время разбора.
  function sweep() {
    var imgs = document.images;
    for (var i = 0; i < imgs.length; i++) {
      var img = imgs[i];
      if (img.hasAttribute('data-src') || img.hasAttribute('data-srcset')) observe(img);
    }
  }

  function wants(img) {
    return img.hasAttribute('data-src') || img.hasAttribute('data-srcset');
  }

  // watch(root) — для внешних вызовов (product-card.js, морфы) и для поддеревьев, вставленных
  // скриптами: точечный обход поддерева.
  function watch(root) {
    if (!root || root.nodeType !== 1) return;
    var list = root.matches && root.matches(SEL) ? [root] : root.querySelectorAll ? root.querySelectorAll(SEL) : [];
    for (var i = 0; i < list.length; i++) observe(list[i]);
  }

  // После разбора: узлы от скриптов. Картинка — по тегу из записи, поддерево — обход внутри него.
  function onMutations(records) {
    for (var i = 0; i < records.length; i++) {
      var r = records[i];
      if (r.type === 'attributes') {
        if (r.target.tagName === 'IMG' && wants(r.target)) observe(r.target);
        continue;
      }
      var added = r.addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.tagName === 'IMG') { if (wants(n)) observe(n); }
        else if (n.firstElementChild) watch(n);
      }
    }
  }

  function startObserver() {
    new MutationObserver(onMutations).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-src', 'data-srcset'] });
    // Generic re-arm for parked images: a container fading in with `visibility` in its transition
    // list (the search panel does) is visible from the first frame of that transition.
    document.addEventListener('transitionstart', function (e) {
      if (e.propertyName === 'visibility' && e.target && e.target.nodeType === 1) watch(e.target);
    }, true);
  }

  // Во время разбора: раз в кадр обход только нового хвоста дерева от последнего виденного элемента.
  var last = document.documentElement;
  var walker = null;
  try { walker = document.createTreeWalker(document.documentElement, 1 /* SHOW_ELEMENT */); } catch (err) {}
  function scanTail() {
    if (!walker) { sweep(); return; }
    // Последний виденный узел мог убрать скрипт (морф) — тогда один раз с начала, seen отсеет старое.
    if (last.isConnected === false) last = document.documentElement;
    walker.currentNode = last;
    var n;
    while ((n = walker.nextNode())) {
      if (n.tagName === 'IMG' && wants(n)) observe(n);
      last = n;
    }
  }
  function parseLoop() {
    if (document.readyState !== 'loading') return;
    scanTail();
    requestAnimationFrame(parseLoop);
  }

  sweep();
  if (document.readyState === 'loading') {
    requestAnimationFrame(parseLoop);
    document.addEventListener('DOMContentLoaded', function () { sweep(); startObserver(); });
  } else {
    startObserver();
  }

  window.r69Lazy = { load: load, watch: watch, sweep: sweep };
})();
